import { Link } from 'react-router-dom';
import ArticleLayout from '@/components/feature/ArticleLayout';

export default function KosztyWysylki() {
  return (
    <ArticleLayout
      title="Koszty wysyłki Kakobuy do Polski — pełne zestawienie 2026"
      subtitle="Ile kosztuje wysyłka z Kakobuy do Polski? Porównujemy wszystkie dostępne metody dostawy, ich ceny, czas oczekiwania i podpowiadamy jak wybrać najlepszą opcję."
      category="Logistyka"
      date="Aktualizacja: Czerwiec 2026"
      breadcrumbLabel="Koszty wysyłki"
    >
      <div className="max-w-4xl mx-auto">
        <div className="space-y-12">
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">Dostępne metody wysyłki</h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p><strong>Kakobuy</strong> oferuje kilka metod wysyłki do Polski, różniących się ceną, czasem dostawy i poziomem bezpieczeństwa. Wybór odpowiedniej metody zależy od Twoich priorytetów — czy zależy Ci bardziej na szybkości, czy na niskim koszcie?</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">Porównanie metod dostawy</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-background-300/60">
                    <th className="text-left py-3 px-4 font-semibold text-foreground-950">Metoda</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-950">Czas dostawy</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-950">Koszt (0.5kg)</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-950">Koszt (2kg)</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-950">Ubezpieczenie</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['DHL Express', '3-5 dni', '~120 PLN', '~220 PLN', 'W cenie'],
                    ['EMS', '7-14 dni', '~80 PLN', '~150 PLN', 'Opcjonalne'],
                    ['EUB', '10-20 dni', '~45 PLN', '~90 PLN', 'Opcjonalne'],
                    ['China Post Air', '15-30 dni', '~35 PLN', '~70 PLN', 'Brak'],
                    ['Cargo Ship', '30-60 dni', '~25 PLN', '~50 PLN', 'Brak'],
                  ].map(([method, time, cost05, cost2, insurance]) => (
                    <tr key={method} className="border-b border-background-200/50 hover:bg-background-100 transition-colors">
                      <td className="py-3 px-4 font-medium text-foreground-800">{method}</td>
                      <td className="py-3 px-4 text-foreground-600">{time}</td>
                      <td className="py-3 px-4 text-foreground-600">{cost05}</td>
                      <td className="py-3 px-4 text-foreground-600">{cost2}</td>
                      <td className="py-3 px-4 text-foreground-600">{insurance}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-xs text-foreground-500 italic mt-2">* Ceny orientacyjne, mogą się różnić w zależności od aktualnych stawek przewoźników.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">Jak zaoszczędzić na wysyłce?</h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>Koszty wysyłki z <strong>Kakobuy</strong> do Polski mogą stanowić znaczącą część całkowitego kosztu zamówienia. Oto kilka sprawdzonych sposobów na obniżenie kosztów dostawy: łącz kilka produktów w jedną paczkę (oszczędzasz na opłacie podstawowej), wybieraj ekonomiczne metody gdy czas nie jest priorytetem, unikaj zamawiania pojedynczych lekkich produktów oraz sprawdzaj <Link to="/" className="text-accent-600 hover:text-accent-700 underline">aktualizacje w Kakobuy Spreadsheet</Link> gdzie często pojawiają się informacje o promocjach na wysyłkę.</p>
              <p>Pamiętaj też że <Link to="/czy-kakobuy-jest-bezpieczny" className="text-accent-600 hover:text-accent-700 underline">bezpieczeństwo przesyłki</Link> jest równie ważne co jej koszt. W przypadku droższych zamówień, warto dopłacić za ubezpieczenie i szybszą dostawę.</p>
            </div>
          </section>

          <div className="bg-primary-50 border border-primary-200 rounded-2xl p-8 md:p-10 text-center">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">Gotowy do zamówienia?</h3>
            <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-md mx-auto">Przeczytaj instrukcję krok po kroku i złóż pierwsze zamówienie.</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/jak-kupowac-przez-kakobuy" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 rounded-full transition-all whitespace-nowrap cursor-pointer">
                Jak kupować
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
              </Link>
              <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-600 hover:text-primary-700 border border-primary-200 hover:border-primary-300 rounded-full transition-all whitespace-nowrap cursor-pointer">
                Strona główna
              </Link>
            </div>
          </div>

          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            '@context': 'https://schema.org', '@type': 'Article',
            headline: 'Koszty wysyłki Kakobuy do Polski — pełne zestawienie 2026',
            description: 'Ile kosztuje wysyłka z Kakobuy do Polski? Porównujemy wszystkie dostępne metody dostawy.',
            author: { '@type': 'Organization', name: 'Kakobuy.study' },
            datePublished: '2026-06-12', dateModified: '2026-06-21', inLanguage: 'pl-PL',
            publisher: { '@type': 'Organization', name: 'Kakobuy.study' },
          }) }} />
        </div>
      </div>
    </ArticleLayout>
  );
}